import { Dropdown } from "react-bootstrap";
import { useEffect, useState } from "react";
import '../../App.css';
import { useAuth } from "../../providers/AuthProvider";
import './headerStyle.css';
import { AdminNavigation } from "./navigation/AdminNavigation";
import { UserNavigation } from "./navigation/UserNavigation";
import EmployerService from "../../pages/members/Services/EmployerService";
import { rateLimitingUrl } from "../../pages/members/Shared/Constants/AppConstant";

export const Header = () => {
    let auth = useAuth();
    let isAuthenticated = auth?.isAuthenticated();
    let isGpDiaryAdmin = auth?.isGpDiaryAdmin();
    let loggedInUserName = auth?.getLoggedInUserName();

    const [isExpanded, setIsExpanded] = useState(false);
    function toggleNavigationMobile() {
        setIsExpanded(!isExpanded);
    }

    function login() {
        auth?.signinRedirect()
    }
    function logout() {
        auth?.logout()
    }

    const [isEmployerExist, setIsEmployerExist] = useState();
    useEffect(() => {
        if (auth?.isAuthorised() && !isGpDiaryAdmin) {
            EmployerService.getEmployers().then((res) => {
                setIsEmployerExist((res.data && res.data.length > 0));
            })
        }
    }, []);

    return (
        <div>
            <nav className="member-menu-bar" aria-label="Member's Menu">
                <div className="container">
                    <div className="member-menu-bar__inner">
                        {!isAuthenticated && (
                            <ul className="nav navbar-nav">
                                <li>
                                    <a className="member-menu-bar-link member-menu-bar-link" href="#" onClick={() => login()}>
                                        Sign in
                                    </a>
                                </li>
                            </ul>
                        )}
                        {isAuthenticated && (
                            <ul className="nav navbar-nav">
                                <Dropdown focusFirstItemOnShow={true}>
                                    <span>{loggedInUserName}</span>
                                    <Dropdown.Toggle variant="link" id="dropdown-flags" className="text-left" style={{ width: "100",}}>
                                        <span className="member-menu-bar-link member-menu-bar-link px-0">
                                            <img src={require("../../assets/images/loginlogo.png")} className="logInLogo"
                                            />
                                        </span>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item style={{ color: "black", textAlign: "center", backgroundColor: "#fff"}} onClick={() => logout()}>
                                            Sign out
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </ul>
                        )}
                    </div>
                </div>
            </nav>
            <header id="js-header" className="header" role="banner">
                <div className="header__inner">
                    <div className="navigation-trigger" id="js-navigation-trigger" onClick={toggleNavigationMobile}>
                        <div className="navigation-trigger-box">
                            <span className="navigation-trigger-box__lines"></span>
                        </div>
                    </div>
                    <a href="https://www.bma.org.uk/" target="_blank" className="logo">
                        <img
                            className="logo__image"
                            src={require("../../assets/images/bma-logo.svg").default}
                            alt="British Medical Assocation Logo"
                        />
                    </a>
                    <div id="js-navigation" className="navigation-wrapper">
                        <nav
                            aria-label="Mega menu"
                            vocab="https://schema.org/"
                            typeof="SiteNavigationElement"
                            className={`navigation ${isExpanded ? "navigation--open" : ""}`}
                            onClick={() => setIsExpanded(false)}
                        >
                            {isAuthenticated && isGpDiaryAdmin && window.location.pathname != rateLimitingUrl && (<AdminNavigation />)}
                            {isEmployerExist && isAuthenticated && !isGpDiaryAdmin && window.location.pathname != rateLimitingUrl && (<UserNavigation />)}

                        </nav>
                        <div className={`navigation-member-buttons ${isExpanded ? "navigation--open" : ""}`}>
                            {!isAuthenticated && (
                                <div>
                                    <a className="navigation-member-buttons-item" href="#" onClick={() => {setIsExpanded(false); login();}} >
                                        <svg className="icon icon--login"></svg>
                                        <span className="text-dark">Sign in</span>
                                    </a>

                                    <a href="/join" className="navigation-member-buttons-item" onClick={() => setIsExpanded(false)}>
                                        <svg className="icon icon--join-us"></svg>
                                        <span className="text-dark">Join us</span>
                                    </a>
                                </div>
                            )}
                            {isAuthenticated && (
                                <a className="navigation-member-buttons-item" href="#" onClick={() => {setIsExpanded(false); logout();}} >
                                    <svg className="icon icon--login"></svg>
                                    <span className="text-dark">Sign out</span>
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </header>
            <div id="js-backdrop" aria-hidden="true" className={`backdrop ${isExpanded ? "show" : ""}`}></div>
        </div>
    );
}